import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import BlogTemplateBanner from "../BlogTemplateBanner"
import ContentfulLongText from "../ContentfulLongText"
import { BlogShareIcons } from "../BlogInteractionWidget"

import "./index.css"

const HeroWithSmallFeature = ({ post, postCategories, postCategoryTitles, formattedDate, socialsList }) => {
    return (
        <div className="variant-small-feature">
            <BlogTemplateBanner variant={post.blogTemplate} post={post} postCategories={postCategories} postCategoryTitles={postCategoryTitles} formattedDate={formattedDate} />
            <div className="blog-content" style={{
                backgroundImage: post.blogContentMedia !== null ? `url(${post.blogContentMedia.image.gatsbyImageData.images.fallback.src})`:'transparent',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundAttachment: 'fixed'
            }}>
                <div className="space-top"></div>
                <div className="container-custom">
                    <div className="grid col-2-6-2 col-1-md gap-10 gap-15-md">
                        <BlogShareIcons socialsList={socialsList} post={post} />
                        {post.introTextStyling !== null ? <ContentfulLongText longTextContent={post.introTextStyling.content.content} classNameProp='text-center' styleVal={{ fontSize: `${post.introTextStyling.fontSize}px`, lineHeight: `${post.introTextStyling.lineHeight}px` }} />:documentToReactComponents(JSON.parse(post.excerpt.raw))}
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeroWithSmallFeature